import * as React from "react";
import { useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { HelpCircle } from "react-feather";
import { LinkStyled, TextStyled } from "../../assets/styles/components/Input";
import { Button } from "../../components/Button";
import {
  BarStyled,
  ButtonWrapper,
  Container,
  FormStyled,
  ImgGlobalBlur
} from "../../assets/styles/views/Steps";
import GlobalBlur from "../../components/GlobalBlur";
import Input from "../../components/Input";
import TicketImageWebID from "../../assets/images/ticket-3.jpg";
import TicketImage from "../../assets/images/ticket-4.jpg";

//actions
import {
  resolvedInvoice,
  resetLoadedData
} from 'store/actions'

import { useInvoice } from "store/context";
import { toast, ToastContainer } from "react-toastify";
import { nonCharacterSpecial } from "utils/validate";
import { useForm } from "hooks/useForm";
import { formatCustomDate } from "utils/dateTools";

const version = process.env.REACT_APP_ENERSI_VERSION || "0.0.0"

const StepOne = () => {
  const navigate = useNavigate();
  const { state: { loadData }, dispatch } = useInvoice();
  const [show, setShow] = React.useState(false);
  const [showWebID, setShowWebID] = React.useState(false);
  const {
    inputValues,
    fieldErrors,
    inputChange,
    runValidates
  } = useForm({
    date: formatCustomDate(new Date()),
    rfc: '',
    webID: '',
    folio: ''
  }, {
    date: { required: true,  },
    rfc: { required: true, },
    webID: { required: true, },
    folio: { required: true, },
  })

  const { date, rfc, webID, folio } = inputValues
  // const [form, setForm] = React.useState({
  //   rfc: '',
  //   webID: '',
  //   folio: ''
  // });
  // //required fields
  // const [requiredField, setRequiredField] = React.useState({
  //   rfc: '',
  //   webID: '',
  //   folio: '',
  // });

  // const handleOnChange = (event) => {
  //   const { name, value } = event.target;
  //   let valueToUpperCaseRFC;
  //   if (name) {
  //     const res = nonCharacterSpecial(value);
  //     if (res) {
  //       toast.error(' * Los campos no puede contener caracteres especiales * ',
  //         { theme: 'colored' }
  //       )
  //       return
  //     }
  //   }


  //   if (name === 'rfc') {
  //     valueToUpperCaseRFC = value.toUpperCase()
  //     setForm((prevState) => ({
  //       ...prevState,
  //       [name]: valueToUpperCaseRFC
  //     }))
  //   } else {
  //     setForm((prevState) => ({
  //       ...prevState,
  //       [name]: value
  //     }))
  //   }
  // }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if(runValidates()) return toast.error(' * Todos los campos son requeridos * ', { theme: 'colored' })

    // const { rfc, webID, folio } = form;
    // if (!rfc) {
    //   setRequiredField((requiredField) => ({ ...requiredField, rfc: 'error' }))
    // }
    // if (!webID) {
    //   setRequiredField((requiredField) => ({ ...requiredField, webID: 'error' }))
    // }
    // if (!folio) {
    //   setRequiredField((requiredField) => ({ ...requiredField, folio: 'error' }))
    // }

    // if (rfc && webID && folio) {
    //   setRequiredField('')
    // }
    await resolvedInvoice(dispatch, date, rfc, webID, folio)

  }

  React.useEffect(() => {
    resetLoadedData(dispatch)
  }, [])
  React.useEffect(
    () => {
      if (loadData === 'resolved') {
        navigate('/facturar')
      }
      //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadData]
  )

  return (
    <>
      <Container>
        <TextStyled>
          Para un mejor servicio tienes el mes en curso de tu consumo para
          solicitar tu factura, dentro del mismo año en que se realizo tu consumo.
          Recuerda que la fecha de la factura corresponde al día que la generas.
        </TextStyled>
        <FormStyled>
          <BarStyled />
          <Input
            requiredField={fieldErrors?.rfc}
            placeholder="Fecha *"
            type="date"
            name="date"
            value={date}
            onChange={inputChange}
            inputProps={{max: formatCustomDate(new Date())}}
          />
          <Input
            requiredField={fieldErrors?.rfc}
            placeholder="RFC *"
            type="text"
            name="rfc"
            value={rfc}
            onChange={inputChange}
            maxLength="14"
          />
          <Input
            requiredField={fieldErrors?.webID}
            icon={<HelpCircle size={20} />}
            placeholder="WEB ID *"
            type="text"
            onClickIcon={() => setShowWebID(true)}
            name="webID"
            value={webID}
            onChange={inputChange}
          />
          <Input
            requiredField={fieldErrors?.folio}
            icon={<HelpCircle size={20} />}
            placeholder="TICKET *"
            type="text"
            onClickIcon={() => setShow(true)}
            name="folio"
            value={folio}
            onChange={inputChange}
          />
          <ButtonWrapper>
            <Button onClick={handleSubmit} disabled={loadData === 'pending' ? true : false}>ENVIAR</Button>
          </ButtonWrapper>
        </FormStyled>
        <p>
          Si tienes problemas para facturar o tu forma de pago es incorrecta, da{" "}
          <LinkStyled
            href="mailto:facturacion@globalgas.com.mx?subject=Dudas con mi facturacion"
          >
            Clic Aquí
          </LinkStyled>
        </p>
        <span>{version}</span>
        <GlobalBlur isOpen={show} onClose={() => setShow(false)}>
          <ImgGlobalBlur
            src={TicketImage}
            alt="informacion del ticket"
          />
        </GlobalBlur>
        <GlobalBlur isOpen={showWebID} onClose={() => setShowWebID(false)}>
          <ImgGlobalBlur
            src={TicketImageWebID}
            alt="informacion del ticket"
          />
        </GlobalBlur>
      </Container>
      <ToastContainer autoClose={4000} />
    </>
  );
};

export default StepOne;
